var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 716,
    height: 720,
    viewBox: "0 0 716 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352 720C298.667 720 250.333 710 207 690C164.333 670 127.333 643 96 609C65.3333 574.333 41.6667 535.667 25 493C8.33333 449.667 7.00355e-07 405 7.00355e-07 359C7.00355e-07 311.667 8.66667 266.667 26 224C44 180.667 68.6667 142.333 100 109C132 75.6667 169.667 49.3333 213 29.9999C256.333 9.99996 303.667 -3.33786e-05 355 -3.33786e-05C407.667 -3.33786e-05 455.333 10.3333 498 31C541.333 51.6666 578.333 79.3333 609 114C640.333 148.667 664.333 187.667 681 231C697.667 273.667 706 317.333 706 362C706 409.333 697.333 454.333 680 497C662.667 539.667 638 578 606 612C574 645.333 536.333 671.667 493 691C450.333 710.333 403.333 720 352 720ZM353 574C384.333 574 411.667 568 435 556C458.333 543.333 477.667 527 493 507C508.333 486.333 519.667 463.333 527 438C535 412 539 385.667 539 359C539 331.667 535 305.333 527 280C519 254 507 231 491 211C475 191 455.333 175.333 432 164C408.667 152 382.333 146 353 146C321.667 146 294.333 152.333 271 165C248.333 177 229 193.333 213 214C197.667 234 186 257 178 283C170.667 308.333 167 334.333 167 361C167 388.333 171 414.667 179 440C187 465.333 198.667 488.333 214 509C230 529 249.667 545 273 557C296.333 568.333 323 574 353 574ZM309 435H463L716 715H562L309 435Z",
    fill: "url(#paint0_linear_154_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_6",
    x1: 352.5,
    y1: -86.5,
    x2: 353,
    y2: 837.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DDEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24428E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.ccdf11d97bf0b96e715efe0fed08839f.svg";
export { ForwardRef as ReactComponent };